import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { usePageTitle } from '@/hooks/usePageTitle';

export const NotFoundPage = () => {
    const navigate = useNavigate();
    usePageTitle('Page Not Found');
    
    const handleGoBack = () => {
        navigate(-1);
    };
    
    const handleGoHome = () => {
        navigate("/dashboard");
    };
    
    return (
        <section className="flex min-h-screen items-start py-16 md:items-center md:py-24" style={{ backgroundColor: '#fcf8f3' }}>
            <div className="mx-auto max-w-7xl grow px-4 md:px-8">
                <div className="flex w-full max-w-3xl flex-col gap-8 md:gap-12">
                    <div className="flex flex-col gap-4 md:gap-6">
                        <div className="flex flex-col gap-3">
                            <span className="text-sm font-semibold text-green-600">404 error</span>
                            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900">We can't find that page</h1>
                        </div>
                        <p className="text-lg text-gray-600 md:text-xl">Sorry, the page you are looking for doesn't exist or has been moved.</p>
                    </div>

                    <div className="flex flex-col-reverse gap-3 sm:flex-row">
                        <Button 
                            variant="outline" 
                            size="lg" 
                            onClick={handleGoBack}
                            className="flex items-center gap-2"
                        >
                            <ArrowLeft className="h-5 w-5" />
                            Go back
                        </Button>
                        <Button 
                            size="lg" 
                            onClick={handleGoHome}
                        >
                            Take me home
                        </Button>
                    </div>
                </div>
            </div>
        </section>
    );
};